// src/data/polesData.js - Contains all pole product data

export const polesData = [
  {
    id: "breakaway-pole",
    name: "BeatDown Outdoors BreakAway Transducer Pole",
    msrp: 550.00,
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=BreakAway+Pole",
    displaySpecs: {
      "Length": "36-48 inches",
      "Type": "Open Water",
      "Handle": "15 inches",
      "Arm Size": "10x10 inches",
      "Base Size": "3x4 inch",
      "Adjustable": "Yes"
    }
  },
  // Add more poles as needed
]; 